import { IComponentOptions } from 'angular';
import { ConfirmStepCtrl } from './confirm-step.controller';

export const ConfirmStepComponent: IComponentOptions = {
  template: require('./confirm-step.html'),
  bindings: {
    prevStep: '&',
    saveSupport: '&',
    currentSupport: '<',
  },
  controller: ConfirmStepCtrl,
};

angular.module('nv.SupportsModule').component('confirmStep', ConfirmStepComponent);
